// export default Home;
import React, { useState } from 'react';
import Navbar from '../../components/Navbar';
import './Home.css';
import { Link } from 'react-router-dom';

const Home = () => {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const videoId = "R0G58EDTyEA";
  const loadVideo = () => {
    setVideoLoaded(true);
  };

  return (
    <div className="home-container">
      <Navbar />

      {/* Hero Section */}
      <section className="hero-section" id="home">
        <div className="hero-content">
          <h1 className="hero-title">Next-Gen CAD Copilot</h1>
          <p className="hero-subtext">
            Instantly turn your design ideas into production-ready 3D CAD models using AI — no manual modeling, no complexity.
          </p>
          <p className="hero-slogan">
            You describe it. We CAD it.
          </p>

          <a href="https://app.pixelateinc.com">
            <button className="hero-button">Start Building with AI</button>
          </a>

          {/* Optimized video embed with thumbnail and click-to-play */}
          <div className="video-container">
            {!videoLoaded ? (
              <div className="video-thumbnail" onClick={loadVideo}>
                <img
                  src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
                  alt="Video thumbnail"
                />
                <div className="play-button">
                  <i className="fas fa-play"></i>
                </div>
              </div>
            ) : (
              <iframe
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
                title="Pixelate Demo"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              ></iframe>
            )}
          </div>

          {/* Optional hero image below the button */}
          <div className="hero-image-container">
            {/* <img
        src="/images/placeholder-hero.png"
        alt="Hero Visual"
        className="hero-image"
      /> */}
          </div>
        </div>
      </section>


      {/* ABOUT SECTION */}
      <section className="about-section" id="about">
        <h2>About Pixelate</h2>
        <p className="about-text">
          Pixelate is a student-founded startup driven by a shared passion for technological innovation and intelligent design.
          We're building AI tools that transform ideas into production-ready CAD models — making design faster, smarter, and accessible to everyone.
        </p>

        {/* Text above university logos */}
        <p className="founding-members-text">Our founding team are from:</p>

        {/* University logos instead of stats */}
        <div className="university-logos">
          <div className="logo-item">
            <img src="/images/cornell-logo.png" alt="Cornell University" className="university-logo" />
          </div>
          <div className="logo-item">
            <img src="/images/berkeley-logo.png" alt="UC Berkeley" className="university-logo" />
          </div>
          <div className="logo-item">
            <img src="/images/ucsd-logo.png" alt="UC San Diego" className="university-logo" />
          </div>
          <div className="logo-item">
            <img src="/images/ucsb-logo.png" alt="UC Santa Barbara" className="university-logo" />
          </div>
        </div>

        {/* Optional image underneath the logos */}
        <div className="about-image-container">
          {/* <img
            // src="/images/Group 1.png"
            alt="About Illustration"
            className="about-image"
          /> */}
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="contact-section" id="contact">
        <h2>Contact Us</h2>
        <p className="contact-text">
          We're always excited to explore new ideas, partnerships, and collaborations.
          Whether you're curious about our work or just want to say hi — we'd love to hear from you!
        </p>

        {/* New contact cards implementation */}
        <div className="contact-cards">
          <a href="mailto:pixelate688@gmail.com" className="contact-card">
            <div className="contact-card-icon">
              <i className="fas fa-envelope"></i>
            </div>
            <p className="contact-card-text">pixelate688@gmail.com</p>
          </a>

          <a href="https://www.instagram.com/pixelate.inc.ai" target="_blank" rel="noopener noreferrer" className="contact-card">
            <div className="contact-card-icon">
              <i className="fab fa-instagram"></i>
            </div>
            <p className="contact-card-text">@pixelate.inc.ai</p>
          </a>

          <a href="https://www.linkedin.com/company/pixelate-ai/" target="_blank" rel="noopener noreferrer" className="contact-card">
            <div className="contact-card-icon">
              <i className="fab fa-linkedin-in"></i>
            </div>
            <p className="contact-card-text">@pixelate-ai</p>
          </a>
        </div>

        {/* Old contact methods implementation - commented out
        <div className="contact-methods">
          <a href="mailto:pixelate688@gmail.com" className="contact-method">
            <div className="contact-icon">
              <i className="fas fa-envelope"></i>
            </div>
            <div className="contact-info">
              <h3>Email</h3>
              <p>pixelate688@gmail.com</p>
            </div>
          </a>
          
          <a href="https://www.instagram.com/pixelate.inc.ai" target="_blank" rel="noopener noreferrer" className="contact-method">
            <div className="contact-icon">
              <i className="fab fa-instagram"></i>
            </div>
            <div className="contact-info">
              <h3>Instagram</h3>
              <p>@pixelate.inc.ai</p>
            </div>
          </a>
          
          <a href="https://www.linkedin.com/company/pixelate-ai/" target="_blank" rel="noopener noreferrer" className="contact-method">
            <div className="contact-icon">
              <i className="fab fa-linkedin-in"></i>
            </div>
            <div className="contact-info">
              <h3>LinkedIn</h3>
              <p>@pixelate-ai</p>
            </div>
          </a>
        </div>
        */}
      </section>


      {/* EXTRA IMAGE SECTION (underneath everything else) */}
      <section className="extra-image-section">
        <div className="extra-image-container">
          <img
            src="/images/Logo 1.png"
            alt="Extra Visual"
            className="extra-image"
          />
        </div>
      </section>


      {/* FOOTER */}
      <footer className="footer-section">
        <p>© 2025 Pixelate. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Home;
